// Fired by the axios interceptor when the server refuses an action because the subscription ran out.
export const SUBSCRIPTION_EXPIRED_EVENT = "padix:subscription-expired";
